module.exports = __webpack_public_path__ + "img/ctrl-pauli-y-root-stub-mid-+.5ca04123.svg";